<template>
  <div id="app">
    <!-- 页面路由总出口 -->
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mounted() {
    document.title = 'CCNT'
  },
  methods: {

  }
}
</script>

<style lang="scss">
@import "@/assets/styles/index.scss";
</style>
